import PinVerifyStep from './PinVerifyStep';

export default PinVerifyStep;
